import {
    MONITORAMENTO_LOADING,
    MONITORAMENTO_LOGS_LOADED,
    MONITORAMENTO_STATS_LOADED,
    MONITORAMENTO_DATES_LOADED,
    MONITORAMENTO_ERROR
} from '../actions/monitoramentoActions';

const initialState = {
    loading: false,
    logs: [],
    pagination: { page: 1, total: 0, per_page: 50, total_pages: 1 },
    stats: null,
    available_dates: [],
    error: null
};

export function monitoramento(state = initialState, action) {
    switch (action.type) {
        case MONITORAMENTO_LOADING:
            return Object.assign({}, state, { loading: true, error: null });

        case MONITORAMENTO_LOGS_LOADED:
            return Object.assign({}, state, {
                loading: false,
                logs: action.payload.data || [],
                pagination: action.payload.pagination || initialState.pagination
            });

        case MONITORAMENTO_STATS_LOADED:
            return Object.assign({}, state, {
                stats: action.payload
            });

        case MONITORAMENTO_DATES_LOADED:
            return Object.assign({}, state, {
                available_dates: action.payload || []
            });

        case MONITORAMENTO_ERROR:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            });

        default:
            return state;
    }
}
